import styled, { css, keyframes } from 'styled-components';
import { Menu, Typography } from 'antd';

export const PageHeader = styled.header`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    z-index: 2;
`;

export const HeaderMenu = styled.div`
    border-radius: 8px;
    padding: 10px 14px;
    cursor: pointer;
    transition: background 0.5s;
    background-color: ${({ theme }) => theme.colors.iconsBg};

    &:hover {
        background-color: ${({ theme }) => theme.colors.iconsBgHover};
    }

    span {
        color: ${({ theme }) => theme.colors.darkBlue};
        font-size: 15px;
    }
`;

export const HeaderMenuTitle = styled(Typography.Text)`
    color: ${({ theme }) => theme.colors.darkBlue};
`;

export const CustomMenu = styled(Menu)`
    margin-top: 20px;
    border-radius: 10px;
    padding: 10px;
`;


const spin = keyframes`
  from { transform: rotate(-90deg); }
  to { transform: rotate(270deg); }
`;

export const IndicatorWrapper = styled.div<{ $status: 'loading' | 'success' | 'error' | 'idle' }>`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background-color: #f0f2f5;
    }
`;

export const IndicatorRingSvg = styled.svg<{ $spinning: boolean }>`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
    border-radius: 50%;

    ${props => props.$spinning && css`
        animation: ${spin} 1.5s linear infinite;
    `}
`;
